import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type HttpError, teamsClient } from '@atlassian/teams-client';
import { isFedramp } from '@atlassian/teams-common/context-config';

import type { StoreApi } from '../types';

export const getTeamHealth =
	(teamId: string) =>
	async ({ setState }: StoreApi) => {
		if (
			(FeatureGates.initializeCompleted() &&
				!FeatureGates.checkGate('enable_atlas_team_health_monitor')) ||
			isFedramp()
		) {
			return;
		}
		setState({
			teamHealth: {
				teamId,
				isLoading: true,
				hasLoaded: false,
				errorType: null,
				data: [],
			},
		});

		try {
			const monitors = await teamsClient.queryTeamHealthMonitors(teamId);
			setState({
				teamHealth: {
					teamId,
					isLoading: false,
					hasLoaded: true,
					errorType: null,
					data: monitors,
				},
			});
		} catch (e) {
			setState({
				teamHealth: {
					teamId,
					isLoading: false,
					hasLoaded: true,
					errorType: e as HttpError,
					data: [],
				},
			});
		}
	};
